/** 从 JSONL 生成快照（#5011）：请求体整理与 `GET /jobs/{job_id}` 的任务形状解析。 */

import { apiUrl, expectRecord, optionalString, query, requireString } from "../api/client";
import { ContractError } from "../api/errors";

export const EXPORT_SOURCES = ["stock_data", "fmp", "news"] as const;

export interface ExportDraft { input: string; source: string; operator: string; reason: string; }

export function exportBody(d: ExportDraft): { ok: true; body: Record<string, string> } | { ok: false; error: string } {
  const missing = [!d.input.trim() && "input（JSONL 路径）", !d.operator.trim() && "operator", !d.reason.trim() && "reason"].filter(Boolean);
  if (missing.length) return { ok: false, error: `请填写：${missing.join("、")}` };
  return { ok: true, body: { input: d.input.trim(), source: d.source || "stock_data", operator: d.operator.trim(), reason: d.reason.trim() } };
}

export interface ExportJob {
  job_id: string;
  status: string;
  error: string | null;
  /** 任务成功时才有；`reused=true` 表示同内容已有快照、未另起一条。 */
  result: { snapshot_id: string; reused: boolean } | null;
}

export function parseExportJob(body: unknown): ExportJob {
  const url = apiUrl("/jobs/{job_id}");
  const r = expectRecord(body, url, "任务");
  const raw = r["result"];
  let result: ExportJob["result"] = null;
  if (raw !== null && raw !== undefined) {
    const x = expectRecord(raw, url, "任务结果");
    if (typeof x["reused"] !== "boolean") throw new ContractError("字段 `result.reused` 应为布尔", url, x);
    result = { snapshot_id: requireString(x, "snapshot_id", url), reused: x["reused"] };
  }
  return { job_id: requireString(r, "job_id", url), status: requireString(r, "status", url), error: optionalString(r, "error"), result };
}

export const readExportJob = (jobId: string) => query<unknown>(`/jobs/${encodeURIComponent(jobId)}`).then(parseExportJob);
